const navs = [
    {name: "labels.logs", url: "/historic/logs/", icon: "fa-comments", role: "superadmin"},
    {name: "labels.history", url: "/historic/history/", icon: "fa-clock-rotate-left", role: "superadmin"},
    {name: "labels.measures", url: "/historic/measures/", icon: "fa-chart-line", role: "superadmin"},
    {name: "labels.recuperator", url: "/historic/recovery/", icon: "fa-repeat", role: "superadmin"},
];

export default navs;
